import { NestApiProvider } from './../../shared/nestjs/nest-api';
import { FileDownloaderProvider } from './../../providers/file-downloader/file-downloader';
import { Platform } from 'ionic-angular';
import { Observable } from 'rxjs';
import { Injectable } from '@angular/core';
import saveAs from 'file-saver';
import { LoanRequestReportApi } from '../../shared/nestjs/gd-integrated/services/loan-request-report.api';
import { AnalyticsProvider } from '../../providers/analytics/analytics';
import { EventNameAnalytics } from '../../helpers/event-name-analytics';

@Injectable()
export class LoanRequestReportBloc {
    constructor(
        private platform: Platform,
        private fileDownloaderProvider: FileDownloaderProvider,
        private nestApiProvider: NestApiProvider,
        private loanRequestReportApi: LoanRequestReportApi,
        private analyticsProvider: AnalyticsProvider
    ) { }

    generateExcel(data) {
        if (this.platform.is('cordova')) {
            this.fileDownloaderProvider.downloadExcelBlob(data, 'Loan Request Report')
        } else {
            saveAs(data, 'Loan Request Report.xlsx')
        }
    }

    downloadExcel(data): Observable<any> {
        this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_DOWNLOAD_EXCEL);
        return this.loanRequestReportApi.downloadExcel(data);
    }

    sendExcel(data): Observable<any> {
        return Observable.fromPromise(this.nestApiProvider.isGoPathNewExist())
            .mergeMap(isGoPathNewExist => {
                this.analyticsProvider.trackEvent(EventNameAnalytics.REPORT_SEND_MAIL);
                return this.loanRequestReportApi.reportSendEmailExcel(data)
            })
    }

    type(): Observable<any> {
        return this.loanRequestReportApi.type();
    }
}


// WEBPACK FOOTER //
// ./src/bloc/report/loan-request-report.bloc.ts